import { combineReducers } from '@reduxjs/toolkit';
import loading, { loadingInitialState } from './slicers/loading.slice';
import apiMessage, { apiMessageInitialState } from './slicers/api-message.slice';
import auth, { authInitialState } from './slicers/auth.slice';
import provider, { providerInitialState } from '@/redux/slicers/provider.slice';
import userManagement, { userManagementInitialState } from '@/redux/slicers/user-management.slice';
import manageRole, { manageRoleInitialState } from '@/redux/slicers/manage-role.slice';
import card, { CardInitialState } from '@/redux/slicers/card.slice';
import permission, { permissionInitialState } from '@/redux/slicers/permission.slice';
import transactions, { transactionsInitialState } from '@/redux/slicers/transactions.slice';
import bank, { bankInitialState } from '@/redux/slicers/bank.slice';
import event, { eventInitialState } from '@/redux/slicers/event.slice';
import audit, { auditInitialState } from './slicers/audit.slice';
import customers, { customerInitialState } from '@/redux/slicers/customer.slice';
import customerRequest, { CustomerRequestInitialState } from './slicers/customer-request.slice';
import stablecoin, { stablecoinInitialState } from '@/redux/slicers/stablecoin.slice';
import ledger, { ledgerInitialState } from '@/redux/slicers/ledger.slice';
import customerDetails, { customerDetailsInitialState } from '@/redux/slicers/customer-details.slice';


export type RawRootState = typeof rootState;
export const allInitialStates = {
  loadingInitialState,
  apiMessageInitialState,
  authInitialState,
  providerInitialState,
  userManagementInitialState,
  manageRoleInitialState,
  CardInitialState,
  permissionInitialState,
  transactionsInitialState,
  bankInitialState,
  eventInitialState,
  auditInitialState,
  customerInitialState,
  CustomerRequestInitialState,
  stablecoinInitialState,
  ledgerInitialState,
  customerDetailsInitialState,
};
const rootState = {
  loading,
  apiMessage,
  auth,
  provider,
  userManagement,
  manageRole,
  card,
  permission,
  transactions,
  bank,
  event,
  audit,
  customers,
  customerRequest,
  stablecoin,
  ledger,
  customerDetails,
};
const rootReducer = combineReducers(rootState);
export const rootReducers = rootReducer;
export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
